module.exports = "https://web-assets.ifttt.com/packs/media/fonts/avenir_next-bold-255fd141.eot";